var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 20,
    viewBox: "0 0 9 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75204 19.9812L0.5625 15.7917L1.763 14.5912L3.88982 16.6783V3.72946L1.77392 5.82754L0.573422 4.62704L4.76296 0.4375L8.9525 4.62704L7.74108 5.85628L5.61397 3.74039V16.6783L7.74108 14.5912L8.94129 15.7917L4.75204 19.9812Z",
    fill: "#893EE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHei);
export default __webpack_public_path__ + "static/media/Hei.17907402e947e1fd19463a67c67bddb5.svg";
export { ForwardRef as ReactComponent };